<template>
    <div class="autocomplete" :class="{'other': getOtherPages === 'ST'}">
        <div class="input right" :class="classname">
            <input :id="id" :ref="inputRefName" type="text" :placeholder="placeholder" v-autoselect autocomplete="off"/>
            <a v-if="showGroupedList" href="javascript:;" :class="btnclass"><i class="icon-arrow-left" @click="revertGroupList"></i></a>
            <a v-else href="javascript:;" :class="btnclass" tabindex="0" role="button" aria-label="search" v-on:keydown.enter="onClick"><i class="icon-search" @click="onClick"></i></a>
        </div>
        <div :class="getClasses">
            <ul v-if="refinedSuggestion || otherSuggestion">
                <template v-for="(autoSuggest,i) in groupedSuggestionLinks">
                    <li :class="{'single-item':autoSuggest.data.length === 1, hover: index ===i}" class="grouped-suggestion" v-if="autoSuggest.data.length" :key="i">
                        <div v-if="autoSuggest.type" class="label">{{autoSuggest.type}}</div>
                        <div class="list-item" :class="{'no-label': !autoSuggest.type}" v-for="(item,i) in autoSuggest.data" :key="i || searchFilter">
                            <a v-if="item.iconAction" class="right" href="javascript:;" @click="iconAction(item)">
                                <i :class="item.icon"></i>
                            </a>
                            <i v-else-if="item.icon" :class="item.icon"></i>
                            <a v-ga:clickable="autoSuggest.type" v-if="item.href" href="javascript:;" @click="action({...item, extraPath: searchFilter})">
                                {{item.groupedText}} <br/><span v-html="item.subText"></span>
                            </a>
                            <a v-ga:clickable="autoSuggest.type" v-else-if="item.action" href="javascript:;" @click='action({...item, extraPath: searchFilter})'>
                                {{item.groupedText}} <br/><span v-html="item.subText"></span>
                            </a>
                        </div>
                    </li>
                </template>
                <li class="powered-google" v-if="searchSuggestions.length && searchSuggestions[0].value && searchSuggestions[0].value.address_components"><img :src="glb.cdnUrl + 'images/desktop/powered_by_google_on_white@3x.png'" /></li>
            </ul>
            <ul v-else>
                <li :class="{hover:index===i}" v-for="(autoSuggest,i) in searchSuggestions">
                    <a @click="saveSerarch" v-if="autoSuggest.type=='searchSave'" class="text-front" >
                        {{autoSuggest.text}}
                    </a>
                    <a v-else-if="autoSuggest.href" href="javascript:;" @click="action(autoSuggest)">
                        {{autoSuggest.text}} <span v-html="autoSuggest.subText"></span>
                    </a>
                    <a v-else-if="autoSuggest.action" href="javascript:;" @click='action(autoSuggest)'>
                        {{autoSuggest.text}} <span v-html="autoSuggest.subText"></span>
                    </a>

                    <a  v-if="autoSuggest.iconAction" class="right" href="javascript:;" @click="iconAction(autoSuggest)">
                            <i :class="autoSuggest.icon"></i>
                    </a>
                    <i v-else-if="autoSuggest.icon" class="right" :class="autoSuggest.icon"></i>
                </li>
                <li class="powered-google" v-if="searchSuggestions.length && searchSuggestions[0].value && searchSuggestions[0].value.address_components"><img :src="glb.cdnUrl + 'images/desktop/powered_by_google_on_white@3x.png'" /></li>
            </ul>
        </div>
    </div>
</template>

<script src="./mvt-autocomplete.js"></script>

<style lang="scss">
    @use "./mvt-autocomplete.scss" as *;
</style>